import { ACTIVATE_ONCE_KEY } from '@esentai/core/features/campaigns/purchaseResult/consts/keys';
import { mapProps } from 'recompose';

import RepetitionForm from './component';

export default mapProps(({ setFieldValue, values }) => ({
  activateOnce: values[ACTIVATE_ONCE_KEY],
  setFieldValue,
}))(RepetitionForm);
